import { environment } from 'src/environment';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseService, SettingsService, StorageService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { DatalayerService } from 'src/app/core/services/datalayer.service';
import { PlanService } from 'src/app/core/services/plan.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { UikitService } from 'src/app/core/services/uikit.service';
import * as UIKit from 'uikit'; 
import { PaymentService } from 'src/app/core/services/payment.service';
import { ApplicationService } from 'src/app/core/services/application.service';
import { InhouseAnalyticsService } from 'src/app/core/services/inhouse-analytics.service';
@Component({
  selector: 'app-change-plan',
  templateUrl: './change-plan.component.html',
  styleUrls: ['./change-plan.component.scss', '../modal-screens.scss']
})
export class ChangePlanComponent implements OnInit {
  subscriptions: any;
  discountFlag: any;
  buttonValue: string;
  oldUser: boolean;
  noSubscriptionText: string;
  subscriptionsLength: any;
  oneTime: any;
  subscribedPlanId: any;
  stripeSubscriptionId: any;
  updatedPayment: any;
  updatePaymentUrl: any;
  selectedPlan: any;
  windowWidth: number;
  step: number;
  nextBillingDate: any;
  uId: any;
  region: any;
  @Output() newItemEvent? = new EventEmitter<string>();
  @Output() updateTitleEvent? = new EventEmitter<string>();
  userId: any;
  disableButton;
  avodPlans: any;
  svodPlans: any;
  displayProratedData = false;
  locale: any;
  isAvodSubscribed = false;
  proratedData;
  currentPlan; //Existed plan of user
  monthsList = [
    this.configService.localeKeys?.["common_keys.january.text"],
    this.configService.localeKeys?.["common_keys.february.text"],
    this.configService.localeKeys?.["common_keys.march.text"],
    this.configService.localeKeys?.["common_keys.april.text"],
    this.configService.localeKeys?.["common_keys.may.text"],
    this.configService.localeKeys?.["common_keys.june.text"],
    this.configService.localeKeys?.["common_keys.july.text"],
    this.configService.localeKeys?.["common_keys.august.text"],
    this.configService.localeKeys?.["common_keys.september.text"],
    this.configService.localeKeys?.["common_keys.october.text"],
    this.configService.localeKeys?.["common_keys.november.text"],
    this.configService.localeKeys?.["common_keys.december.text"],
  ];
  @Input() page;
  @Input() planData;
  freePlanStep;
  paymentMethodLength: any;
  payment_type: any;
  subTitleText: string;
  paymentDialog = true;
  @Input() initialPaymentStep;
  @Output() contentDetailPaymentStep = new EventEmitter();

  skinName = environment.skinName;
  paymentGateway: string;
  constructor(private subscriptionService: SubscriptionService, private baseService: BaseService,
    private planService: PlanService, private storageService: StorageService,
    private router: Router, private uikitService: UikitService, private settingsService: SettingsService,
    public configService: ConfigurationService, private route: ActivatedRoute, private analyticsService: InhouseAnalyticsService,
    private datalayerService: DatalayerService, private paymentService: PaymentService, private appService: ApplicationService) {
      this.step = 1;
      this.freePlanStep = 0;
      this.userId = this.storageService.getLocalStore('u_id');
      UIKit.util.on(document, 'beforehide', '#change-subscription', ()=>{
        this.step = 1;
        this.freePlanStep = 0;
        this.subscription_index();
        this.displayProratedData = false;
      });
    this.uId = this.storageService.getLocalStore('u_id');
    this.region = this.storageService.getLocalStore('region');
    this.locale = this.storageService.getLocalStore('locale');
    }

  ngOnInit(): void {
    this.step = 1;
    if(this.planService.plansLength>0)this.subscription_index();
    this.paymentGateway = this.settingsService.paymentGateway;
  }


  subscription_index() {
    this.subscriptions = [];
    if(this.page == 'account'){
      this.userPlanData(this.planData)
    }else{
      this.getNewPlans();
    }
  }

  userPlanData(data){
    this.baseService.loaderSource.next(false);
    this.noSubscriptionText = '';
    this.avodPlans = data.plans.filter(plan => plan.with_ads === 1);
    this.svodPlans = data.plans.filter(plan => plan.with_ads === 0);
    this.subscriptions = data.plans;
    this.subscriptionsLength = data.plans.length;
    this.oneTime = data.one_time_subscription;
    
    if (this.subscriptions.length === 0) {
      this.noSubscriptionText = this.configService.localeKeys?.["plans.no_subscription_plan_avaliable.text"];
    }
    if (data.subscribed_plan_id) {
      this.subscribedPlanId = data.subscribed_plan_id;
      this.subscriptions = this.subscriptions.map(subs => {subs.selected_plan = (subs.subscription_id === this.subscribedPlanId) ? true: false;return subs});
      this.currentPlan = this.subscriptions.find(plan => plan.subscription_id == this.subscribedPlanId);
      this.isAvodSubscribed = this.currentPlan?.with_ads ? false : true;
      this.stripeSubscriptionId = data.stripe_subscription_id;
      // this.nextBillingDate = this.selectedPlan.expiry_date
    }
    this.updatedPayment = data.update_payment;
    this.updatePaymentUrl = data.update_payment_url;
  }

  viewPlanGTM(plan){
    const datalayerData = {
      event: 'GAEvent',
      eventCategory: 'Payment',
      eventAction: 'View',
      eventLabel: plan.title,
      platform: this.baseService.browserType,
      loginStatus: 'True',
      userId: (this.uId ? this.uId : ''),
      notificationStatus: localStorage.getItem('emailNotify') ||  'False',
      region: (this.storageService.getLocalStore('region') ? this.storageService.getLocalStore('region') : ''),
      userType: this.storageService.getLocalStore('user_type'),
    };
    this.datalayerService.addDatalayer(datalayerData);
  }


  checkout(plan, redirection) {
    const postData = {
      u_id: this.storageService.getLocalStore('u_id'),
      subscription_id: plan.subscription_id,
      stripe_plan_id: plan.stripe_plan_id,
      pricing_plan_id: plan.pricing_plan_id
    };
    this.subscriptionService.checkOut(postData).subscribe((data) => {
      if (data) {
        const session_id = data.session_id;
        this.subscriptionService.paymentSessionId = data.session_id;
        const queryParams = { session_id }
        this.router.navigate(['/payment/stripe'], { queryParams })
      }
    });
  }

  updatePayment(plan) {
    const postData = {
      u_id: this.storageService.getLocalStore('u_id'),
      subscription_id: plan.subscription_id,
      stripe_plan_id: plan.stripe_plan_id,
      pricing_plan_id: plan.pricing_plan_id
    };
    this.subscriptionService.updateRedirect(postData).subscribe((data) => {
      if (data) {
        const session_id = data.session_id;
        const queryParams = { session_id };
        this.router.navigate(['/payment/update'], { queryParams })
      }
    })
  }

  changePlanApi(plan) {
    this.baseService.loaderSource.next(false);
    const data = {
      u_id: this.storageService.getLocalStore('u_id'), subscription_id: plan.subscription_id,
      old_subscription_id: this.subscribedPlanId, stripe_subscription_id: this.stripeSubscriptionId,
      stripe_plan_id: plan.stripe_plan_id,
      pricing_plan_id: plan.pricing_plan_id
    };
    this.subscriptionService.changePlanApiFun(data).subscribe((Resdata) => {
      this.baseService.loaderSource.next(false);
      this.disableButton.removeAttribute("disabled");
      this.updateTitleEvent.emit(this.configService.localeKeys?.["account.success.text"]);
      if (Resdata) {
        this.subscription_index();
        this.step = 3;
        this.newItemEvent.emit('');
      }
    }, (error) => {
      this.uikitService.notifyError(error)
      this.baseService.loaderSource.next(false);
      this.disableButton.removeAttribute("disabled");
    });
  }

  onPlanSwitch() {
    if (this.selectedPlan?.free_plan) {
      const req = {
        locale: this.locale,
        region: this.region,
        subscription_id: this.selectedPlan.subscription_id,
      };
      this.subscriptionService.getFreePlanSubscription(req).subscribe(data => {
        this.step = 3;
      });
    } else {
      this.displayProratedAmount();
    }
  }

  displayProratedAmount() {
    const request = {
      locale: this.locale,
      region: this.region,
      subscription_id: this.selectedPlan.subscription_id,
      old_subscription_id: this.subscribedPlanId,
      stripe_subscription_id: this.stripeSubscriptionId,
      stripe_plan_id: this.selectedPlan.stripe_plan_id,
      pricing_plan_id: this.selectedPlan.pricing_plan_id
    };
    
    this.subscriptionService.getProratedAmount(request).subscribe((data) => {
      this.displayProratedData = true;
      this.proratedData = data;
      this.nextBillingDate = this.proratedData?.next_billing_date ? new Date(this.proratedData?.next_billing_date).getDate() + ' ' +  this.monthsList[new Date(this.proratedData?.next_billing_date).getMonth()] + ' ' + new Date(this.proratedData?.next_billing_date).getFullYear() : '';
      if (this.proratedData.next_billing_date) this.proratedData.conertedBillingDate = this.monthsList[(new Date(this.proratedData.next_billing_date).getMonth())] + ' ' + new Date(this.proratedData.next_billing_date).getDate() + ', ' + new Date(this.proratedData.next_billing_date).getFullYear()
      
    });
  }

  changePlanBtnClick() {
    // storing selected plan data as it is needed in other places like card details, signup page
    this.storageService.setSessionStore('selectedPlanData', this.selectedPlan);
    if (this.currentPlan?.free_plan) {
      const postData = {
        u_id: this.storageService.getLocalStore('u_id'),
        subscription_id: this.selectedPlan?.subscription_id,
        stripe_plan_id: this.selectedPlan?.stripe_plan_id,
        pricing_plan_id: this.selectedPlan.pricing_plan_id
      };
      this.storageService.setLocalStore('subsId', this.selectedPlan?.subscription_id);
      this.subscriptionService.checkOut(postData).subscribe((data) => {
        if (data) {
          this.subscriptionService.paymentSessionId = data.session_id;
          // if stripe payment methods(like card,ideal)length is greater than 1, then we'll show step2 which shows payment methods popup else we'll redirect to step3 which shows existed single payment type
          if (this.appService.userPaymentMethods?.length > 1) {
            this.freePlanStep = 2;
          } else {
            this.freePlanStep = 3;
            this.payment_type = this.appService.userPaymentMethods[0];
          }
          this.step = 0;
        }
      });
    } else this.step = 2;
    
    const uId: string = this.storageService.getLocalStore('u_id');
    const region: string = this.storageService.getLocalStore('region');
    const datalayerData = {
      event: 'GAEvent',
      eventCategory: 'Payment',
      eventAction: 'Plan Selected',
      eventLabel: this.baseService.selectPlan,
      platform: this.baseService.browserType,
      loginStatus: 'True',
      userId: (uId ? uId : ''),
      notificationStatus: localStorage.getItem('emailNotify') ||  'False',
      region: ( region? region : ''),
      userType: this.storageService.getLocalStore('user_type'),
      operator: this.storageService.getLocalStore('operator_name')
    };
    this.datalayerService.addDatalayer(datalayerData);

    const eventObj = {
      event_type: 'event',
      event_name: 'Upgrade Plan Selected',
      event_status: 'Success',
      value: this.selectedPlan.amount,
      payment_type:this.paymentGateway,
      subscription_status: this.storageService.getLocalStore('user_type'),
      paid_user: this.storageService.getLocalStore('user_type'),
      subscription_plan: this.selectedPlan.title,
    };
    this.analyticsService.trackUserActions(eventObj);
    // this.changePlanApi(this.selectedPlan);
    // UIKit.modal('#change-subscription').hide();
  }

  changePlan() {
    this.disableButton = document.querySelector('#iAgreeBtn');
    this.disableButton.setAttribute('disabled', '');
    this.changePlanApi(this.selectedPlan);
  }
  
  resumePlanApi(plan) {
    this.baseService.loaderSource.next(false);
    const paramData = {
      u_id: this.userId,
      subscription_id: plan.subscription_id,
      stripe_subscription_id: this.subscribedPlanId
    };
    this.subscriptionService.resumePlanApiFun(paramData).subscribe((data) => {
      this.baseService.loaderSource.next(false);
      if (data) {
        const eventObj = {
          event_type: 'event',
          event_name: 'Resume Subscription',
          event_status: 'Success',
          value: this.selectedPlan.amount,
          payment_type: this.paymentGateway,
          subscription_status: this.storageService.getLocalStore('user_type'),
          paid_user: this.storageService.getLocalStore('user_type'),
          subscription_plan: this.selectedPlan.title,
        };
        this.analyticsService.trackUserActions(eventObj);

        this.getNewPlans();
        this.newItemEvent.emit('');
      }
    }, (error) => {
      this.baseService.loaderSource.next(false);
      const eventObj = {
        event_type: 'event',
        event_name: 'Resume Subscription',
        event_status: 'Failure',
        value: this.selectedPlan.amount,
        payment_type: this.paymentGateway,
        subscription_status: this.storageService.getLocalStore('user_type'),
        paid_user: this.storageService.getLocalStore('user_type'),
        subscription_plan: this.selectedPlan.title,
        event_description: error
      };
      this.analyticsService.trackUserActions(eventObj);
    });
  }

  getNewPlans(){
    this.subscriptionService.userPlan().subscribe((data) => {
      if (data) {
        this.userPlanData(data)
      }
    }, (error) => {
      this.baseService.loaderSource.next(false);
    });
  }

  resumePlan() {
      this.resumePlanApi(this.currentPlan);
      UIKit.modal('#change-subscription').hide();
  }

  selectPlan(plan) {
    this.selectedPlan = plan;
    this.onPlanSwitch();
  }

  selectedPlanGTM(planTitle:string): void {
    const uId: string = this.storageService.getLocalStore('u_id');
    const region: string = this.storageService.getLocalStore('region');
    const datalayerData = {
      event: 'GAEvent',
      eventCategory: 'Payment',
      eventAction: 'Plan Selected',
      eventLabel: planTitle,
      platform: this.baseService.browserType,
      loginStatus: 'True',
      userId: (uId ? uId : ''),
      notificationStatus: localStorage.getItem('emailNotify') ||  'False',
      region: ( region? region : ''),
      userType: this.storageService.getLocalStore('user_type'),
      operator: this.storageService.getLocalStore('operator_name')
    };
    this.datalayerService.addDatalayer(datalayerData);
  }

  cardMethod(e) {
    this.freePlanStep = 3;
    this.paymentMethodLength = e.paymentMethodLength;
    this.paymentService.paymentMethodLength = e.paymentMethodLength;
    this.payment_type = e.payment_type;
  }

  cardPayment(e) {
    const paymentDetail = e.url_data;
    if (paymentDetail) {
      this.subTitleText = paymentDetail.next_due_date ?
      ((this.configService.localeKeys?.["plans.next_payment_wii_be_charged.text"] || 'Your new plan will be valid starting from')
      + ' ' + paymentDetail.next_due_date +
      (this.configService.localeKeys?.["plans.next_payment_will_be_charged_part2.text"] || '.')) : '';
      this.freePlanStep = 4;
    }
  }

  idealPayment(data) {
    this.baseService.loaderSource.next(false);
    this.freePlanStep = 4;
  }

  getSignStep($event) {
    if (this.currentPlan?.free_plan && $event != 1 ) this.freePlanStep = $event;
    else {
      this.step = $event;
      this.freePlanStep = 0;
    }
  }
}
